export enum HomeTabsEnum {
    Requests = 1,
    Subsidiaries,
    Agreements,
    NewRequests
}

export enum HomeSubtabsEnum {
    Subdivision = 1,
    Mains,
    Services
}
